<div class="logs-signpost-custom-waf-rule">
    <ng-content></ng-content>

    <avi-dynamic-data-grid
        *ngIf="trafficLogsSignpostStore.logsWafRuleSignpostData$ | async as logsWafRuleSignpostData"
        class="logs-signpost-custom-waf-rule__wrapper"
        [config]="logListGridConfig"
        [rows]="logsWafRuleSignpostData"
        [rowsTotal]="logsWafRuleSignpostData.length"
        [isLoading]="trafficLogsSignpostStore.isLoading$ | async"
    ></avi-dynamic-data-grid>
</div>

<div
    class="logs-signpost-custom-waf-rule__loader clr-wrapper"
    *ngIf="trafficLogsSignpostStore.isLoading$ | async"
>
    <clr-spinner [clrMedium]="true"></clr-spinner>
</div>

<ng-template
    #nameFieldTemplateRef
    let-row
    let-index="index"
>
    <div
        *ngIf="trafficLogsSignpostStore.logSelectedSignpostConfigKey$ | async as configKey"
        class="logs-signpost-custom-waf-rule__content"
    >
        <ng-container *ngFor="let value of row.values; trackBy: trackByIndex">
            <span
                *ngIf="value.isValid"
                class="logs-signpost-custom-waf-rule__content-separator"
                logFilter
                [property]="value.param"
                [value]="value.value"
                (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
                aviTitle="{{ value.value | signpostLogDataTransform: configKey }}"
            >
                {{ value.value | signpostLogDataTransform: configKey }}
            </span>
            <span
                *ngIf="!value.isValid"
                logFilterableEmptyField
                [property]="value.param"
                (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
            ></span>
            </ng-container>
    </div>
</ng-template>

<ng-template
    #progressBarFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-progress-bar
        [percentage]="row.percentage"
        [hidePercentage]="true"
    ></avi-progress-bar>
</ng-template>
